import {
  type BaseChoice,
  SelectScreen,
} from 'components/Funnelling/screens/SelectScreen';
import {
  FunnellingBackButton,
  FunnellingArticle,
  FunnellingFooter,
} from '../styles';
import { useJob } from '../job.context';
import RAQGuidance from '../components/RAQGuidance';
import type { ScreenCommonProps } from '../types';
import { useRAQJobStartDate } from '@hooks/use-raq-job-startdate';

export const JobStartScreen = ({
  onBack,
  onComplete,
  isRequestAQuote,
}: ScreenCommonProps) => {
  const { setJobField } = useJob();
  const { title, options } = useRAQJobStartDate();

  const choices: BaseChoice[] = options.map(option => ({
    ...option,
    value: option.value,
    title: option.label,
  }));

  const handleSelect = (option: unknown) => {
    const { label, value, level } = option as any;

    setJobField('preferredStart', { label, option: value, level });

    onComplete && onComplete();
  };

  return (
    <FunnellingArticle>
      <SelectScreen
        title={title}
        choices={choices}
        onSelect={handleSelect}
        showSubheading
      />

      {isRequestAQuote && <RAQGuidance />}
      <FunnellingFooter>
        <FunnellingBackButton onClick={onBack} />
      </FunnellingFooter>
    </FunnellingArticle>
  );
};
